import { Button, Theme, alpha, styled } from "@mui/material";

interface ChatInputButtonProps {
  selected?: boolean;
  theme?: Theme;
}

export const ChatInputButtonStyled = styled(Button, {
  shouldForwardProp: (prop) => prop !== "selected",
})<ChatInputButtonProps>(({ theme, selected = false }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: selected
    ? alpha(theme.palette.primary.light, 0.2)
    : "transparent",
  color: selected ? theme.palette.primary.main : theme.palette.text.primary,
  textTransform: "none",
  borderRadius: "20px",
  padding: selected ? "2px 8px" : "8px",
  minWidth: selected ? "auto" : "fit-content",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: selected
      ? alpha(theme.palette.primary.light, 0.4)
      : "transparent",
    color: theme.palette.primary.main,
  },
}));
